import React, { FC, useCallback } from 'react';
import { IconButton } from '@chakra-ui/react';
import { Icon } from '../Icon/component';
import { Layout } from '../Layout';
import { i18n } from '../../../i18n';

interface Props {
  inputRef: React.RefObject<HTMLInputElement | HTMLTextAreaElement>;
  clearField?: () => void;
}

export const ClearInputButton: FC<Props> = ({ inputRef, clearField }) => {
  const resetField = useCallback(() => {
    if (clearField) {
      clearField();
    }
    if (!inputRef.current) {
      return;
    }
    inputRef.current.value = '';
    inputRef.current.focus();
  }, [inputRef, clearField]);

  return (
    <IconButton
      onClick={resetField}
      variant="ghost"
      colorScheme="gray"
      isRound={true}
      paddingX={0}
      aria-label={i18n.t('Clear field')}
      icon={
        <Layout pointerEvents="none">
          <Icon prefix="fas" iconName="xmark-circle" />
        </Layout>
      }
    />
  );
};
